angular.module('wbDashboard').controller('WelcomeControllerAurea',
    ['$scope', '$q', '$timeout', 'User', 'Milestone', 'Message', 'Auth', 'Display', 'Session', 'Track', 'PlanService',
function ($scope, $q, $timeout, User, Milestone, Message, Auth, Display, Session, Track, PlanService) {

    $scope.pageData = {
        page: 'intro'
    };
    $scope.pages = ['intro', 'plan']; // 'invite'
    $scope.welcome = { intro: {}, dates: {}, deposits: {} };

    Milestone.clearMS();
    $scope.milestone = Milestone.ms;
    $scope.MS = Milestone;
    // $scope.MS.signup = true; //to update frequency
    $scope.currentYear = new Date().getFullYear();

    //hide menu
    Display.setMenu(false);

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.overview = overview;
            $scope.bank = overview.account_overview[0].bank_accounts[0];
        }
    });

    $scope.$watch(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones && Object.keys(milestones).length) {
            var milestone = milestones[Object.keys(milestones)[0]];
            Milestone.setMilestoneUpdateFromObject(milestone);
            $scope.milestone = Milestone.ms;
            Milestone.setBirthDate($scope.overview.user.birth_date);

            Milestone.ms.extra.min_initial_deposit = 500;

            $scope.setInitialDepositInfo();

        } else {
            //placeholder data
            Milestone.ms = Milestone.loadingMilestone;
            $scope.milestone = Milestone.ms;
        }
    }, true);

    $scope.$watch('milestone.auto_deposit.amount', function(autoAmount) {
        if ($scope.milestone.type_account) return;

        if ((autoAmount || autoAmount === 0) && $scope.pageData.page === 'auto-deposit') {
            $scope.pageData.sending = true;
            Milestone.changedAutoDeposit().finally(function() {
                $scope.pageData.sending = false;
            });

        }
    });
    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    $scope.$watch('pageData.page', function(page) {
        switch (page) {
            case "plan":
                Track.send("View Welcome Admire Your Plan", "welcome");
                break;
            case "auto-deposit":
                Track.send("View Welcome Update Auto Deposit", "welcome");
                break;
            case "initial-deposit":
                Track.send("View Welcome Update Initial Deposit", "welcome");
                break;
            case "invite":
                Track.send("View Welcome Invite Screen", "welcome");
                break;
        }
        angular.element("html, body").scrollTop(0);
    });

    /**
     * Handles processing of submitting initial or auto deposits.  Will only submit if data has been changed
     */
    $scope.updateDeposit = function() {
        if ($scope.pageData.page === 'auto-deposit') {
            if ($scope.milestone.extra.auto_deposit_original !== $scope.milestone.auto_deposit.amount) {
                Track.send("Update Auto Deposit", "welcome");
                $scope.updateAutoDepositAmount();
            } else {
                $scope.pageData.page = 'plan';
            }
        }
        if ($scope.pageData.page === 'initial-deposit') {
            if ($scope.welcome.deposits.initial !== $scope.milestone.initial_deposit) {
                Track.send("Update Initial Deposit", "welcome");
                $scope.updateInitialDeposit();
            } else {
                $scope.pageData.page = 'plan';
            }
        }
    };
    $scope.setPageDefaults = function() {
        Milestone.setSectionDefaults("auto-deposit");
    };
    $scope.updateAutoDepositAmount = function() {
        $scope.pageData.sending = true;

        var data = Milestone.prepareSubmitData($scope.milestone);
        //User.updateFrequency(data.funding.auto_deposit_frequency)
        Milestone.update(data).then(function() {
            updateWelcome();

            Message.set({
                text: "Successfully updated auto-deposit info!",
                type: "success"
            });

            User.retrieveOverview(true);
            User.retrieveMilestones($scope.milestone.id, true);

            PlanService.user.retrieveAutos();

        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.page = 'plan';
            $scope.pageData.sending = false;
        });

    };
    $scope.updateInitialDeposit = function() {
        $scope.pageData.sending = true;

        var data = {
            amount: $scope.milestone.initial_deposit,
            metadata: {}
        };

        Milestone.updateInitialDeposit(data).then(function() {
            updateWelcome();

            Message.set({
                text: "Successfully updated initial deposit info!",
                type: "success"
            });

        }).catch(function(err) {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.page = 'plan';
            $scope.pageData.sending = false;
        });

    };

    function updateWelcome() {
        User.welcome().then(function (welcome) {
            $scope.welcome = welcome;

            $scope.setInitialDepositInfo();
        }).catch(function () {
            $scope.welcome = {
                intro: {
                    header: "Rising To The Top",
                    message: "Great Job! Your new Milestone will put you ahead of many Americans with little to no savings",
                    button_text: "See Your plan",
                    link_text: null,
                    link: null, //can be NULL is no link
                },
                dates: {
                    first_deposit: null,
                    est_achievement: null,
                    auto_deposits: [ //NULL is no auto
                    ]
                },
                deposits: {
                    initial: null
                }
            };
        });
    }
    updateWelcome();

    //initial deposit on milestone obj can only be set once both milestone and welcome calls have completed
    $scope.setInitialDepositInfo = function() {
        if ($scope.milestone.id && $scope.welcome.intro.message) {
            $scope.milestone.initial_deposit = $scope.welcome.deposits.initial;

            //this is dependant on the initial_deposit so needs to be called here
            Milestone.getNewDefaultAutoDeposit();
        }
    };

    $scope.trackIntroLink = function() {
        Track.send("Click Source Link", "welcome", {
            url: $scope.welcome.intro.link
        });
    };


    $scope.goNextPage = function() {
        //get current page, find next item on list, go there
        var pageIndex = $scope.pages.indexOf($scope.pageData.page);
        if (pageIndex >= $scope.pages.length - 1) {
            //submit form
            $scope.leaveWelcome();
        } else {
            $scope.pageData.page = $scope.pages[pageIndex+1];
        }
    };

    $scope.leaveWelcome = function() {
        //doesn't refresh after agreement, so must refresh now
        $scope.pageData.leavingWelcome = true;
        Session.clear("welcomeTour");
        Display.setMenu(true);
        Display.setViewToMain();
        $scope.$state.go('base.overview');
        angular.element("html, body").scrollTop(0);
    };


    /**
     * Prevent hitting back and ending up in signup again
     */
    $scope.$state.go('.', {'#': 'wb'});
    function stayWelcomed() {
        $timeout(function() {
            //need a second '#' history state for transition to trigger on back button
            $scope.$state.go('.', {'#': 'welcome'});
        });
    }
    stayWelcomed();
    var transitionBeforeDeregisterHook = $scope.$transitions.onBefore({from: 'base.**'}, function(trans) {
        if (trans.$to().name !== "public.logout") {
            if (!$scope.pageData.leavingWelcome && trans.params('to')['#'] !== 'welcome') {
                if (trans.params('to')['#'] === 'wb') {
                    //needs to move back for #wb to update in order to move forward back to #welcome
                    stayWelcomed();
                    return true;
                }
                return false;
            }
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionBeforeDeregisterHook) {
            transitionBeforeDeregisterHook();
        }
    });



}]);
